// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analyticspg-inline-1 {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 6px;
}

.analyticspg-inline-2 {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 4px;
}

.analyticspg-inline-3 {
  text-align: center;
  padding: 30px;
}

.analyticspg-inline-4 {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.analyticspg-inline-5 {
  height: 260px;
}

.analyticspg-inline-6 {
  height: 260px;
}

.analyticspg-inline-7 {
  height: 260px;
}

.analyticspg-inline-8 {
  height: 260px;
}

.analyticspg-inline-9 {
  height: 260px;
}

.analyticspg-inline-10 {
  height: 260px;
}

.analyticspg-inline-11 {
  display: grid;
  grid-template-columns: repeat(4,minmax(0,1fr));
  gap: 10px;
}

.analyticspg-inline-12 {
  font-size: 12px;
  color: #64748b;
}

.analyticspg-inline-13 {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  margin-top: 6px;
}

.analyticspg-dyn-1 {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
  background: var(--analyticspg-1-background);
}

.analyticspg-dyn-value {
  font-size: 24px;
  font-weight: 800;
  color: var(--analyticspg-value-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/AnalyticsPg.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC","sourcesContent":[".analyticspg-inline-1 {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 6px;\n}\n\n.analyticspg-inline-2 {\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 4px;\n}\n\n.analyticspg-inline-3 {\n  text-align: center;\n  padding: 30px;\n}\n\n.analyticspg-inline-4 {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.analyticspg-inline-5 {\n  height: 260px;\n}\n\n.analyticspg-inline-6 {\n  height: 260px;\n}\n\n.analyticspg-inline-7 {\n  height: 260px;\n}\n\n.analyticspg-inline-8 {\n  height: 260px;\n}\n\n.analyticspg-inline-9 {\n  height: 260px;\n}\n\n.analyticspg-inline-10 {\n  height: 260px;\n}\n\n.analyticspg-inline-11 {\n  display: grid;\n  grid-template-columns: repeat(4,minmax(0,1fr));\n  gap: 10px;\n}\n\n.analyticspg-inline-12 {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.analyticspg-inline-13 {\n  font-size: 22px;\n  font-weight: 800;\n  color: #0f172a;\n  margin-top: 6px;\n}\n\n.analyticspg-dyn-1 {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px;\n  background: var(--analyticspg-1-background);\n}\n\n.analyticspg-dyn-value {\n  font-size: 24px;\n  font-weight: 800;\n  color: var(--analyticspg-value-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
